import { onlineManager } from '@tanstack/react-query';
import onlineProductDetailsRepositoryOfflineAdapters from '../../../modules/offline/offlineRequestAdapters/onlineProductDetails.repository.offlineAdapters';
import onlineProductDetailsRepository from './onlineProductDetails.repository';

const productDetailsRepository = (isOfflineMode = false) =>
  isOfflineMode || !onlineManager.isOnline()
    ? onlineProductDetailsRepositoryOfflineAdapters()
    : onlineProductDetailsRepository();

export default productDetailsRepository;
